import React, { useEffect, useState } from 'react';
import { motion, useTransform, useMotionValue } from 'framer-motion';

const Preloader = ({ onFinished }) => {
  const [progress, setProgress] = useState(0);
  const progressValue = useMotionValue(0);

  const barColor = useTransform(
    progressValue,
    [0, 100],
    ["#e2e8f0", "#a6192e"]
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => {
        const next = prev + 2;
        progressValue.set(next);
        if (next >= 100) {
          clearInterval(timer);
          setTimeout(onFinished, 600);
          return 100;
        }
        return next;
      });
    }, 30);
    return () => clearInterval(timer);
  }, [onFinished, progressValue]);

  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ y: '-100%', opacity: 0 }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
      className="fixed inset-0 z-[1000] bg-white flex flex-col items-center justify-center overflow-hidden"
    >
      <div className="relative flex flex-col items-center z-10">
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ 
            scale: [1, 1.03, 1], 
            opacity: 1 
          }}
          transition={{ 
            opacity: { duration: 0.8 },
            scale: { duration: 2, repeat: Infinity, ease: "easeInOut" } 
          }}
          className="mb-12"
        >
          <img 
            src="/grupo_diana_01.png" 
            alt="Logo" 
            className="w-32 md:w-44 h-auto object-contain drop-shadow-[0_10px_20px_rgba(0,0,0,0.05)]"
          />
        </motion.div>

        <div className="w-64 h-[3px] bg-gray-100 rounded-full overflow-hidden relative border border-gray-50">
          <motion.div 
            className="absolute top-0 left-0 h-full"
            style={{ 
              width: `${progress}%`,
              backgroundColor: barColor,
              boxShadow: progress > 50 ? "0 0 15px rgba(166,25,46,0.2)" : "none"
            }}
          />
        </div>

        <div className="mt-8 flex flex-col items-center gap-1">
            <span className="font-mono text-[9px] text-slate-400 font-bold tracking-[0.5em] uppercase italic">
              Sincronizando Sistema
            </span>
            <span className="font-black text-slate-900 text-3xl italic tracking-tighter">
              {progress}<span className="text-[#a6192e]">%</span>
            </span>
        </div>
      </div>

      <motion.div 
        animate={{ 
          opacity: [0.05, 0.12, 0.05],
          scale: [1, 1.2, 1]
        }}
        transition={{ duration: 4, repeat: Infinity }}
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#a6192e] rounded-full blur-[180px] pointer-events-none" 
      />
    </motion.div>
  );
};

export default Preloader;